import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { translate, isNullOrEmpty, closeCollapsible } from '../../../utils/util';
import { onValueChange, validateInputsRequired } from '../../../utils/handleChangeHooks';
import { Input, BackButton, Button, Title, Select } from '../../../components/UI/ComponentsUI';
import LogListItem from './LogListItem'
import { setSelectedLog } from '../../../actions/logAction';
import { VISIONS } from '../../../utils/constants';
import { getVision } from '../../../services/auth';
import InfiniteScrollUl from '../../../components/UI/InfiniteScrollUl';
import PhysicalConfirmationService from '../../../services/PhysicalConfirmationService';
import CollapsibleUI from '../../../components/UI/CollapsibleUI';
import InputUI from '../../../components/UI/InputUI';

const LogList = (props) => {
    const [currentPage, setCurrentPage] = useState(0);
    const [logs, setLogs] = useState([]);
    const [filter, setFilter] = useState(
        {
            invoice: undefined,
            mvmNumber: undefined,
            journey: undefined,
            partnumbercode: undefined,
            cim: undefined,
            jsonRequest: undefined
        });

    // SST-1431: As operações são fixas
    const operations = [
        'CCF001',
        'CCF002',
        'LCF001',
        'LCF002',
        'LCF003'
    ]

    useEffect(() => {
        setFilter(props.filter);

        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (props.logs?.items?.length > 0) {
            if (logs.length > 0 && currentPage === 0) {
                setLogs([...props.logs.items]);
            } else {
                setLogs((prevState) => ([...prevState, ...props.logs.items]));
            }
        } else {
            setLogs([]);
        }
        // eslint-disable-next-line
    }, [props?.logs?.items]);

    useEffect(() => {
        if (currentPage > 0) {
            onClick();
        }
        // eslint-disable-next-line
    }, [currentPage]);

    const onChange = (event) => {
        onValueChange(event, filter, setFilter);
    };

    const onClick = () => {
        props.setFilter(filter);
        if (validateInputsRequired("formLog")) {
            props.getLogs(Object.assign(filter, {
                PageSize: 25,
                PageIndex: currentPage
            }), () => {
                closeCollapsible("filterLogs");
            })
        }
    }

    const onClickItem = item => {
        props.setSelectedLog(item);
        props.history.push('/receipt/V2/logdetails');
    }

    const validateRequired = () => {
        if (getVision() === VISIONS.Faasa || getVision() === VISIONS.FaasaCKD) {
            return isNullOrEmpty(filter?.invoice)
        } else {
            return isNullOrEmpty(filter?.mvmNumber)
        }
    }

    return (
        <div>
            <BackButton {...props} />
            <div className="container-fluid h-65">
                <div className="row">
                    <Title icon="mdi mdi-clipboard-list-outline" label="Logs" />
                </div>
            </div>
            <div className="container-fluid" style={{ marginTop: '20px' }}>
                <div className="container" style={{ marginTop: '0px', }}>
                    <CollapsibleUI
                        id="filterLogs"
                        header={translate('filter', 'physical-confirmation')}
                        body={
                            <div className="row">
                                <div className="input-field no-padding col s6">
                                    {
                                        getVision() === VISIONS.Faasa || getVision() === VISIONS.FaasaCKD ?
                                            < Input
                                                id="invoice"
                                                name="invoice"
                                                label={translate('invoice', 'physical-confirmation')}
                                                type="text"
                                                defaultValue={filter?.invoice || ''}
                                                onChange={onChange}
                                            /> :
                                            <Input
                                                id="mvmNumber"
                                                name='mvmNumber'
                                                required
                                                label={translate('mvm', 'physical-confirmation')}
                                                type="text"
                                                defaultValue={filter?.mvmNumber || ''}
                                                onChange={onChange}
                                            />
                                    }
                                </div>
                                <div className="input-field no-padding col s5">
                                    <Input
                                        id="journey"
                                        name='journey'
                                        label={translate('journey', 'physical-confirmation')}
                                        type="text"
                                        defaultValue={filter?.journey || ''}
                                        onChange={onChange}
                                        required={validateRequired()}
                                    />
                                </div>
                                <div className="input-field no-padding col s6">
                                    <InputUI
                                        id="partnumbercode"
                                        name='partnumbercode'
                                        label={translate('part-number', 'physical-confirmation')}
                                        type="text"
                                        numericonly="true"
                                        maxLength={11}
                                        defaultValue={filter?.partnumbercode || ''}
                                        onChange={onChange}
                                        padleftchar="0"
                                    />
                                </div>

                                <div className="input-field no-padding col s5">
                                    <InputUI
                                        id="cim"
                                        name='cim'
                                        label={translate('cim', 'physical-confirmation')}
                                        maxLength={10}
                                        type="text"
                                        defaultValue={filter?.cim || ''}
                                        onChange={onChange}
                                        padleftchar="0"
                                    />
                                </div>

                                <div className="input-field no-padding col s5">
                                    <Select
                                        id="jsonRequest"
                                        name="jsonRequest"
                                        valuefield="description"
                                        display="description"
                                        label={translate('operation', 'physical-confirmation')}
                                        data={operations.map((i) => { return { description: i }; })}
                                        defaultValue={filter?.jsonRequest || ''}
                                        change={onChange} />
                                </div>


                            </div>
                        }
                    />
                    <div className="row" style={{ paddingTop: '5px' }}>
                        <Button
                            full="true"
                            text="Buscar"
                            onClick={() => onClick()}
                        />
                    </div>
                </div>
                <InfiniteScrollUl
                    page={props.logs?.totalPages}
                    current={{ currentPage, setCurrentPage }}
                    hasMore={currentPage < props.logs?.totalPages}
                    data={logs.map((item) => {
                        return <LogListItem
                            key={`key_${item.logId}`}
                            onClickItem={item => onClickItem(item)}
                            item={item} />
                    })}
                />
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        logs: state.logReducer.logs,
        filter: state.physicalConfirmationReducer.filter,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getLogs: (filter, callback) => {
            dispatch(PhysicalConfirmationService.getLogs(filter, callback));
        },
        setSelectedLog: (log) => {
            dispatch(setSelectedLog(log));
        },
        setFilter: (filter) => {
            dispatch(PhysicalConfirmationService.setFilter(filter));
        },
    }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(LogList)));
